import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated, useUserRole } from '@/stores/authStore';

interface RoleGuardProps {
  allow: Array<'admin' | 'editor' | 'viewer'>;
  children: ReactNode;
}

export function RoleGuard({ allow, children }: RoleGuardProps) {
  const isAuthenticated = useIsAuthenticated();
  const role = useUserRole();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (!allow.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
